import { DashboardShell } from "../components/dashboard-shell/dashboard-shell";
import { DashboardView } from "../features/dashboard/dashboard-view";

export function DashboardPage(): JSX.Element {
  return (
    <DashboardShell>
      <DashboardView />
    </DashboardShell>
  );
}
